<template>
    <div v-loading="loading">
      <van-nav-bar
          :style="{'paddingTop':statusBarHeight,'backgroundColor':'#FFFFFF'}"
          title="电子凭证"
          left-arrow
          @click-left="onClickLeft"
      />
      <iframe id="preview" ref="Iframe" type="application/x-google-chrome-pdf" :src="PreviewURL" width="100%" height="700px" allowfullscreen frameborder="0" scrolling="no"></iframe>
      <div class="downloadUrl">
          <a :href="downloadUrl" download="电子凭证" target="_self">下载</a>
      </div>
    </div>
</template>

<script>
import {htmlPdf} from '../libs/offlineOrderHtml';
export default {
    name:'offllineOrderCertificate',
    data(){
        return {
          PreviewURL:'',
          downloadUrl:'',
          statusBarHeight: 0,
          loading:false,
        }
    },
    created(){
        // let offlineOrder =  sessionStorage.getItem('offlineOrder');
        // this.htmlToPdf(JSON.parse(offlineOrder))
    },
    mounted(){
        this.iframeLoad();
        this.$nextTick(() => {
          this.downloadUrl = sessionStorage.getItem('certificateUrl') || '';
          this.PreviewURL = sessionStorage.getItem('certificateViewUrl') || '';
          console.log(this.PreviewURL,'PreviewURL=')
        })
        
    },
    methods:{
      // 调用方法
      iframeLoad() {
        this.loading = true;
        const iframe = this.$refs.Iframe;
        // 兼容处理
        if (iframe.attachEvent) {
          // IE
          iframe.attachEvent("onload", () => {
            this.loading = false;
          });
        } else {
          // 非IE
          iframe.onload = () => {
            this.loading = false;
          };
        }
      },
      onClickLeft(){
          this.$router.go(-1)
      },
      onDownloadUrl(){

      },
      setCompatible() {
          if(localStorage.getItem('type') == 'iOS') {
              this.statusBarHeight = `${localStorage.getItem("statusBarHeight")|| 0}px`;
              this.bottomSafeHeight = `${localStorage.getItem("bottomSafeHeight")|| 0}px`;
          }
      },
      htmlToPdf(item){
          const html = htmlPdf(item);
          console.log(html,'html');
          const data = {
            html:html,
            orderNo:item.orderNo
          }
          this.$api.account.htmlToPdf({data}).then(res=>{
              console.log(res);
              if(res.data){
                  this.downloadUrl = res.data.downloadUrl;
                  this.PreviewURL= res.data.viewpdfUrl;
              }
          })
        },
    }
}
</script>

<style lang="less" scoped>
.downloadUrl{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 16px 30px 4px;
    background-color: #fff;
    box-shadow: inset 0px 1px 0px 0px #EBEDF2;
    a{
      width: 690px;
      height: 88px;
      text-align: center;
      background-color: #316FFF;
      color: #fff;
      border-radius: 50px;
      line-height: 88px;
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      display: inline-block;
    }
  
}
</style>